// @ts-check
import React from "react"
import Button from "../atoms/Button.atom"
import { clsx } from "../../utils/strings.utils"

/** @type {import("./ButtonWithCounter.compund.types")["ButtonWithCounter"]} */
export function ButtonWithCounter({ icon, count, children, ...props }) {
  return (
    <Button
      {...props}
      className={clsx(
        "button-with-counter border-round-3xl justify-content-center align-items-center flex gap-3 rounded",
        props.className
      )}
    >
      {icon && <div className="button-with-counter__icon">{icon}</div>}
      {children && (
        <div className="button-with-counter__children">{children}</div>
      )}
      <div className="button-with-counter__count border-round-3xl">{count}</div>
    </Button>
  )
}
